// 入口：先看有没有新版本（有就刷新，PWA 每次打开都是最新版），同时探测内网直连（最多 1.5 秒），然后渲染
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { lan } from "./lib/net";
import { bootCheck, startPwa } from "./lib/pwa";
import "./styles/global.css";

async function boot() {
  const [updating] = await Promise.all([bootCheck(), lan.start()]);
  if (updating) return;
  createRoot(document.getElementById("root") as HTMLElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
  startPwa();
}

void boot();
